__turbopack_context__.v({
  "container": "nGaSdq_container",
  "iconUser": "nGaSdq_iconUser",
  "name": "nGaSdq_name",
});
